export default function StatsSection() {
  const stats = [
    { icon: 'ri-user-star-line', value: '500万+', label: '月活跃用户', color: 'text-primary-500' },
    { icon: 'ri-article-line', value: '100万+', label: '精品内容', color: 'text-accent-500' },
    { icon: 'ri-group-line', value: '10万+', label: '认证创作者', color: 'text-secondary-500' },
    { icon: 'ri-thumb-up-line', value: '98.6%', label: '用户满意度', color: 'text-primary-500' },
  ];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-200/70">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">平台数据</h2>
          <p className="text-sm text-foreground-500 mt-2">用数据说话，见证蜜桃传媒的成长</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="bg-background-50 rounded-lg p-6 md:p-8 text-center">
              <div className={`w-12 h-12 mx-auto mb-3 rounded-full flex items-center justify-center ${stat.color} bg-background-100`}>
                <i className={`${stat.icon} text-xl`} />
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}